import React from 'react'
import { Modal } from 'antd'
import FileTable from './FileTable'
import FileUploadForm from './FileUploadForm'

const UploadFileModal = ({ job, user, setUploadFiles, uploadFiles, files, setFiles, socket }) => {
  return (
    <Modal
      title={
        <div className="um-modal-title">
          <span className="um-modal-title-text">Uploaded Files</span>
        </div>
      }
      visible={uploadFiles}
      width={680}
      className="um-modal"
      footer={null}
      onCancel={() => setUploadFiles(false)}
      centered
      bodyStyle={{ padding: '20px 24px', background: '#f8fffe' }}
    >
      <div className="um-body">
        <FileUploadForm user={user} job={job} setFiles={setFiles} socket={socket} />
        <div className="um-divider" />
        <FileTable user={user} files={files} job={job} setFiles={setFiles} socket={socket} />
      </div>
    </Modal>
  )
}

export default UploadFileModal
